import { render, staticRenderFns } from "./BsIconToggle.vue?vue&type=template&id=1e36e0aa&"
import script from "./BsIconToggle.vue?vue&type=script&lang=js&"
export * from "./BsIconToggle.vue?vue&type=script&lang=js&"
import style0 from "./BsIconToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports